<template>
    <div class="player-label" :class="{ [color]: true, [themeClass]: themeClass }">
        <span class="royal-coin-wrapper">
            <royal-coin :color="color" :theme="theme" />
        </span>

        <router-link :to="`/matches/${encodeLabel(label)}`" class="link player-label-username" target="_blank" v-if="linkToProfile">
            <span class="text">
				{{ this.renderPlayerName(label) }}
			</span>
			<HelmetIcon class="robot-icon" v-if="player.user.ai" />
        </router-link>

        <span class="text player-label-username" v-if="!linkToProfile">
            {{ this.renderPlayerName(label) }}
        </span>
        <span class="time-remaining-wrapper" v-if="timeRemainingMs">
            <fa-icon class="timeout-icon" icon="hourglass-half" />
            <span class="time-remaining">{{ formatTimeRemaining(timeRemainingMs) }}</span>
        </span>
        <span class="initiative-indicator" v-if="showInitiative && hasInitiative">
            <fa-icon icon="crown" class="initiative-icon" />
        </span>
        <span class="menu-wrapper" v-if="renderMenu" @click="toggleMenu">
            <fa-icon class="player-menu-icon" icon="caret-down" />
            <div class="player-menu" v-if="showMenu" @click="showBlockUserModal">
                Block user
            </div>
        </span>
    </div>
</template>

<script>
import { formatUsername } from '../../helpers/general';
import HelmetIcon from '../../assets/helmet.svg';

import {
    formatTimeRemaining,
} from '../TimeoutBlitz/TimeoutBlitz-helpers';

export default {
    components: {
		HelmetIcon,
    },
    props: [
        'player',
        'turnLabel',
        'linkToProfile',
        'renderMenu',
        'timeRemainingMs',
        'theme',
    ],
    name: 'PlayerLabel',
    data() {
        return {
            showMenu: false,
            formatTimeRemaining,
        };
    },
    computed: {
        numOfPlayers() {
            return this.$store.state.gameState.numOfPlayers;
        },
        showInitiative() {
            return !this.turnLabel && this.numOfPlayers === 4;
        },
        color() {
            return this.player.team.color;
        },
        label() {
            return this.formatUsername(this.player.user.username);
        },
        hasInitiative() {
            return this.player.hasInitiative;
        },
        themeClass() {
            return this.theme ? this.theme.toLowerCase() : '';
        },
    },
    methods: {
        renderPlayerName(text) {
            let playerName = text.length >= 15 ? `${text.slice(0, 12)}...` : text;

            if (this.turnLabel) {
                playerName = this.renderTurnLabel(playerName);
            }

            return playerName;
        },
        renderTurnLabel(text) {
            return `${text}${text.charAt(text.length - 1) === 's' ? "'" : "'s"} turn`;
        },
        formatUsername(username) {
            return formatUsername(username);
        },
        encodeLabel(label) {
            return encodeURIComponent(label);
        },
        toggleMenu() {
            this.showMenu = !this.showMenu;
        },
        showBlockUserModal() {
            this.$store.dispatch('openModal', {
                type: 'blockUser',
                data: {
                    blockedUserId: this.player.user.id,
                },
            });
        },
    },
};
</script>

<style scoped lang="scss">
    @use "@/styles/styles.scss" as *;

    .player-label {
        border: 1px solid silver;
        border-radius: 4px;
        display: inline-flex;
        padding: 5px 10px;
        position: relative;
        white-space: nowrap;

        > *{
            align-self: center;
        }

        &.white {
            background: white;

            .link {
                color: $dark-blue;
            }
        }

        &.black {
            background: $dark-gray;
            color: $silver;
            border-color: $dark-gray;

            .royal-coin {
                border: 1px solid $silver;
                border-radius: 50%;
            }

            .link {
                color: $silver;
            }

            &.tk {
                background: $bear-dark-brown;
                border-color: $bear-brown;
                color: $bear-peach;

                .link {
                    color: $bear-peach;
                }

                .royal-coin {
                    border: 1px solid $bear-peach;
                }
            }
        }

        .time-remaining-wrapper {
            display: inline-flex;
            margin-left: 3.5px;

            .time-remaining {
                margin-left: 2px;
                min-width: 24.5px;
            }

            > * {
                align-self: center;
            }
        }

        .initiative-indicator {
            margin-left: 5px;
            line-height: 1.2em;

            .initiative-icon {
                color: $royal-coin-white;
                font-size: .8em;
                vertical-align: middle;
            }
        }

        .royal-coin-wrapper {

            .royal-coin {
                height: 16px;
                width: 16px;
                display: block;
            }
        }

        .text {
            margin-left: 5px;
        }

        .menu-wrapper {
            cursor: pointer;
            padding: 0 7.5px 0 7.5px;
            margin-right: -7.5px;
            position: relative;

            .player-menu-icon {
                font-size: .85rem;
            }

            .player-menu {
                background: white;
                border-radius: 4px;
                border: 1px solid $light-gray;
                box-shadow: -1px 1px 2px -1px $gray;
                color: $dark-gray;
                cursor: pointer;
                font-size: .85rem;
                padding: 3px 4px;
                position: absolute;
                right: 0;
                bottom: -5px;
                transform: translateY(100%);
                white-space: nowrap;
                z-index: 100;
            }
        }
    }

    .score-board {

        .player-label {

            .text {
                display: none;
            }
        }
    }

    .draft-area {

        .player-label {

            &.black {

                .link {
                    color: $dark-blue;
                }
            }
        }
    }

    .player-mat {

        .player-label {
            padding: 3px 8px;

            .text {
                align-self: center;
                font-size: .9em;
            }

            .royal-coin-wrapper {
                align-self: center;

                .royal-coin {
                    height: 14px;
                    width: 14px;
                }
            }
        }
    }

    .units-container-mobile {

        .player-label {
            background: transparent;
            border: none;
            font-size: .75em;
            margin-top: 10px;
            padding: 0;

            .royal-coin {
                width: 31px;
                height: 31px;
            }

            .text {
                display: none;
                margin-left: 0;
            }
        }
    }

    @media only screen and (min-width: $screen-sm) and (max-width: $screen-md) {

        .score-board {

            .player-label {

                .text {
                    display: none;
                }
            }
        }
    }

	@media only screen and (min-width: $screen-sm) {

        .score-board {

            .player-label {

                .text {
					display: flex;
					justify-content: center;
					align-items: center;
                }
            }
        }
    }

	.player-label-username {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.robot-icon {
		height: 14px;
		width: 14px;
		margin-left: 6px;
	}

</style>
